// src/components/autoCompleteSinisterResponsible/AutoCompleteSinisterResponsible.tsx
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useDebounce } from "../../hooks";
import { IListagemUsuario, userService } from "../../services/api/user/userService";

interface IAutoCompleteresponsibleProps {
	isExternalLoading?: boolean;
	labelSelect?: string;
	selected: (user: IListagemUsuario | null) => void;
	idSinister: string;
	fullWidth?: boolean;
	style?: React.CSSProperties;
	value?: IListagemUsuario | null;
}

export const AutoCompleteSinisterResponsible: React.FC<IAutoCompleteresponsibleProps> = ({
	isExternalLoading = false,
	labelSelect = "",
	selected,
	idSinister,
	fullWidth,
	style,
	value,
}) => {
	const { debounce } = useDebounce();
	const [busca, setBusca] = useState("");
	const [opcoes, setOpcoes] = useState<IListagemUsuario[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isEdit, setIsEdit] = useState(false);

	useEffect(() => {
		setIsLoading(true);
		debounce(() => {
			userService
				.getManagers(isEdit ? "" : busca, idSinister)
				.then((result) => {
					setIsLoading(false);
					if (!(result instanceof Error)) {
						setOpcoes(result.data);
					}
				})
				.catch(() => setIsLoading(false));
		});
	}, [busca, idSinister]);

	const selectedOption = useMemo(() => {
		if (value) return opcoes.find((opt) => opt.id === value.id) || null;
		return null;
	}, [value, opcoes]);

	return (
		<Autocomplete
			disablePortal
			options={opcoes}
			value={selectedOption}
			loading={isLoading || isExternalLoading}
			getOptionLabel={(option) => option.name}
			isOptionEqualToValue={(option, val) => option.id === val?.id}
			onInputChange={(_, newValue) => {
				setIsEdit(false);
				setBusca(newValue);
			}}
			onChange={(_, newValue) => {
				selected(newValue ?? null);
			}}
			renderInput={(params) => <TextField {...params} label={labelSelect} fullWidth={fullWidth} variant="outlined" size="small" />}
			style={style || { width: "95%" }}
			popupIcon={isExternalLoading || isLoading ? <CircularProgress size={28} /> : undefined}
			noOptionsText="Nenhum responsável encontrado"
		/>
	);
};
